import { render, staticRenderFns } from "./LigetCard.vue?vue&type=template&id=497c571c&scoped=true&"
import script from "./LigetCard.vue?vue&type=script&lang=js&"
export * from "./LigetCard.vue?vue&type=script&lang=js&"
import style0 from "./LigetCard.vue?vue&type=style&index=0&id=497c571c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c571c",
  null
  
)

export default component.exports